<template>
  <div class="view-lead">
    <vx-card class="project-detail mb-6" :title="$t('labels.project_details')">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-row mb-6">
            <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
              <label>{{ $t("labels.project_name") }}:</label>
            </div>
            <div class="vx-col sm: w-1/2 label-center">
              <span>{{ project.name }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
              <label>{{ $t("labels.date") }}:</label>
            </div>
            <div class="vx-col sm: w-1/2 label-center">
              <span>{{ project.date | only_date_format }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
              <label>{{ $t("labels.vessel") }}:</label>
            </div>
            <div class="vx-col sm: w-1/2 label-center">
              <router-link
                class="view-link"
                :to="{ name: 'ViewVessel', params: { id: project.vessel.id } }"
                v-if="checkPermission('vessel', 'view') && project.vessel"
              >
                {{ project.vessel.name }}
              </router-link>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
              <label>{{ $t("labels.reviewer") }}:</label>
            </div>
            <div class="vx-col sm: w-1/2 label-center">
              <router-link
                class="view-link"
                :to="{ name: 'ViewUser', params: { id: project.reviewer.id } }"
                v-if="checkPermission('user', 'view') && project.vessel"
              >
                {{ project.reviewer.name }}</router-link
              >
              <span v-else>{{ project.reviewer.name }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
              <label>{{ $t("labels.services") }}:</label>
            </div>
            <div class="vx-col sm: w-1/2 label-center">
              <span>{{ services }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm: w-1/2 md:w-1/5 label-center">
              <label>{{ $t("labels.ports") }}:</label>
            </div>
            <div class="vx-col sm: w-1/2 label-center">
              <span v-if="project.port">{{ project.port.name }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm: w-1/2 md:w-1/5 sm:mb-6 md:mb-0 label-center">
              <label>{{ $t("labels.remarks") }}:</label>
            </div>
            <div class="vx-col sm: w-1/2 label-center">
              <span class="line-spacing">{{ project.remarks }}</span>
            </div>
          </div>
          <div class="status">
            <vs-chip color="primary" class="status-name">
              {{ project.status_name }}
            </vs-chip>
          </div>
          <!--          <div class="vx-row">-->
          <!--            <div class="vx-col sm: w-full md:w-full sm: mb-2 label-center">-->
          <!--              <label>{{ $t("labels.images") }}:</label>-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="w-full overflow-x-auto flex">-->
          <!--            <span v-for="(image, index) in project.images" :key="index" class="pr-0 image-size">-->
          <!--              <div v-if="image.url" class="mr-2 mb-4">-->
          <!--                <a :href="image.url" target="_blank">-->
          <!--                  <img :src="image.url" alt="Image" />-->
          <!--                </a>-->
          <!--              </div>-->
          <!--            </span>-->
          <!--          </div>-->
        </div>
      </div>
    </vx-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // project_name: "",
      // date: "",
      // vessel_name: "",
      // reviewer_name: "",
      services: "",
      // service: [],
      // status: "",
      // services_drop: [],
      // remarks: ""
    };
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },

  computed: {},
  // mounted() {
  //   this.getProject();
  // },
  watch: {
    project: function () {
      // watch it
      this.getProject();
    },
  },
  methods: {
    getFileName(url) {
      var filename = url.substring(url.lastIndexOf("/") + 1);
      return filename;
    },
    // API Integration for getData
    async getProject() {
      let service = [];
      this.project.services.forEach((element) => {
        service.push(element.name);
      });
      this.services = service.join(" , ");
    },
  },
};
</script>
<style scoped>
.view-leads label {
  font-weight: 600;
  margin-right: 10px;
}

h2 {
  font-size: 20px;
  font-weight: 600;
  color: rgba(var(--vs-dark), 1);
}

.consultant-border {
  border-bottom: 2px solid #f8f8f8;
}

.question-feather {
  vertical-align: middle;
}

.label-center {
  align-self: center !important;
}

a,
a:hover {
  color: #626262;
  text-decoration: none;
}

.line-spacing {
  display: block;
  width: 670px;
  word-wrap: break-word;
}
</style>
